import { render, staticRenderFns } from "./SalesMatrix.vue?vue&type=template&id=412e0f9a&scoped=true"
import script from "./SalesMatrix.vue?vue&type=script&lang=js"
export * from "./SalesMatrix.vue?vue&type=script&lang=js"
import style0 from "./SalesMatrix.vue?vue&type=style&index=0&id=412e0f9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412e0f9a",
  null
  
)

export default component.exports